import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import clientSlice from "./slices/clientSlice";
import activeTabSlice from "./slices/activeTabSlice";
import selectedChatSlice from "./slices/selectedChatSlice";
import langSlice from "./slices/langSlice";
import userSlice, { setUserData } from "./slices/userSlice";
import categorySlice from "./slices/selectedCategorySlice";
import detailIdSlice from "./slices/detailIdsSlice";
import SearchKeys, { setSearchKeys } from "./slices/searchKeysSlice";
import userRoutes, { setUserRoutes } from "./slices/userRoutes";
import { AdminRoutes } from "../routes";
import productPaginateSlice from "./slices/productPageSlice";
import packagePaginateSlice from "./slices/packagePageSlice";
import { persistReducer, persistStore } from "redux-persist";
import userPackagePaginateSlice from "./slices/userPackageSlice";
import settingsSlice, { fetchSettings } from "./slices/settingSlice";
import userPlanPageSlice from "./slices/pagination/userPlanPageSlice";
import inventoryPageSlice from "./slices/pagination/inventoryPageSlice";
import promotionalBlockPageSlice from "./slices/pagination/promotionalBlockPageSlice";
import salePageSlice from "./slices/pagination/salePageSlice";
import blogPageSlice from "./slices/pagination/blogPageSlice";
import blogSubscriberPageSlice from "./slices/pagination/blogSubscriberPageSlice";
import charityOrganizationPageSlice from "./slices/pagination/charityOrganizationPageSlice";
import donationPageSlice from "./slices/pagination/donationPageSlice";
import brandPageSlice from "./slices/pagination/brandPageSlice";
import giftCardPageSlice from "./slices/pagination/giftCardPageSlice";
import promoCodePageSlice from "./slices/pagination/promoCodePageSlice";
import blogTopicPageSlice from "./slices/pagination/blogTopicPageSlice";
import eventCategoryPageSlice from "./slices/pagination/eventCategoryPageSlice";
import contentPageSlice from "./slices/pagination/contentPageSlice";

const user = JSON.parse(localStorage.getItem("user_data_admin"));
let routes = JSON.parse(localStorage.getItem("user-routes"));

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["activeTab", "detailIdReducer"],
};

const rootReducer = combineReducers({
  clientTab: clientSlice,
  activeTab: activeTabSlice,
  activeChat: selectedChatSlice,
  userData: userSlice,
  selectedcategory: categorySlice,
  detailIdReducer: detailIdSlice,
  searchKeysReducer: SearchKeys,
  userRoutesReducer: userRoutes,
  languageReducer: langSlice,
  productPaginationReducer: productPaginateSlice,
  packagePaginationReducer: packagePaginateSlice,
  userPackagePaginationReducer: userPackagePaginateSlice,
  settingsReducer: settingsSlice,
  userPlanPaginationReducer: userPlanPageSlice,
  inventoryPaginationReducer: inventoryPageSlice,
  promotionalBlockPaginationReducer: promotionalBlockPageSlice,
  salePaginationReducer: salePageSlice,
  blogPaginationReducer: blogPageSlice,
  blogSubscriberPaginationReducer: blogSubscriberPageSlice,
  charityOrganizationPaginationReducer: charityOrganizationPageSlice,
  donationPaginationReducer: donationPageSlice,
  brandPaginationReducer: brandPageSlice,
  giftCardPaginationReducer: giftCardPageSlice,
  promoCodePaginationReducer: promoCodePageSlice,
  blogTopicPaginationReducer: blogTopicPageSlice,
  eventCategoryPaginationReducer: eventCategoryPageSlice,
  contentPaginationReducer: contentPageSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

store.dispatch(fetchSettings());
store.dispatch(setUserData(user));
// store.dispatch(
//   setSearchKeys({
//     ...store.getState().searchKeysReducer.searchKeys,
//     vendorId: user?.adminId,
//   }),
// );
// store.dispatch(
//   setSearchKeys({
//     ...store.getState().searchKeysReducer.searchKeys,
//     vendorsForPackage: user?.adminId,
//   }),
// );

if (user?.role?.role === "admin") {
  store.dispatch(setUserRoutes(AdminRoutes));
} else {
  let temmArr = [];

  routes?.map((itemmm) => {
    let ress = AdminRoutes?.find((elemmm) => elemmm?.name == itemmm?.name);

    temmArr.push({
      ...itemmm,
      component: ress.component,
    });
  });
  store.dispatch(setUserRoutes(temmArr));
}

export const persistor = persistStore(store);
